import { rufe } from './client';

/**
 * Der Empfang am Kurstag (TAG-73, BUC-53).
 *
 * ============================================================================
 * DIE PLÄTZE OHNE NAMEN SIND DER GRUND FÜR DIESE LISTE
 * ============================================================================
 *
 * TAG-73: „Ist ein Teilnehmer beim Check-in noch keiner Gruppe zugeordnet, wird
 * er sichtbar an den Empfang verwiesen, statt eine leere oder vorläufige Angabe
 * zu erhalten. Der Empfang sieht diese Fälle in einer Arbeitsliste."
 *
 * Ein Platz ohne Namen (BUC-69) ist dieser Fall: Ein Firmenkunde bucht fünf
 * Plätze, drei Namen kommen nach — und am Morgen stehen fünf Menschen da, von
 * denen zwei in keiner Liste stehen.
 */

/** `null` heißt noch nicht erfasst — nicht „abwesend". */
export type Anwesenheit = 'anwesend' | 'abwesend' | null;

export type Empfangsplatz = {
  readonly teilnehmer: string;
  /** Die laufende Nummer in der Buchung — „Platz 3 von 5" (BUC-69). */
  readonly platz: number;
  /** `null` ist der Fall aus TAG-73 und kein Datenfehler. */
  readonly name: string | null;
  readonly buchung: string;
  readonly buchungsnummer: string;
  readonly kundenname: string | null;
  readonly anwesenheit: Anwesenheit;
  readonly anwesenheitAm: string | null;
};

export type Empfangstermin = {
  readonly termin: string;
  /** UTC nach ISO 8601; die Anzeige rechnet in Ortszeit um (FRS-01). */
  readonly beginn: string;
  readonly terminart: string;
  readonly produkt: string;
  readonly artikelnummer: string;
  readonly plaetze: readonly Empfangsplatz[];
};

export async function tag(
  standort: string,
  datum: string,
): Promise<{ readonly termine: readonly Empfangstermin[] }> {
  return rufe(
    `/empfang?standort=${encodeURIComponent(standort)}&tag=${encodeURIComponent(datum)}`,
  );
}

/**
 * Einen Platz abhaken — oder den Haken zurücknehmen.
 *
 * `null` ist ein gültiger Wert: Wer den falschen Platz angehakt hat, setzt ihn
 * auf „noch nicht erfasst" zurück. „Abwesend" wäre dafür falsch — das ist eine
 * Feststellung und kein Zurücknehmen.
 */
export async function abhaken(
  teilnehmer: string,
  anwesenheit: Anwesenheit,
): Promise<{ readonly erfasst: true }> {
  return rufe(`/empfang/teilnehmer/${encodeURIComponent(teilnehmer)}/anwesenheit`, {
    verfahren: 'POST',
    rumpf: { anwesenheit },
  });
}
